/**
 *
 * Asynchronously loads the FileRecollectionDrawer component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
